import { getChangeLogLevelUrl } from "config/paths";

export default (level, token) => {
  const fetchOptions = {
    method: "POST",
    mode: "cors",
  };

  return fetch(getChangeLogLevelUrl(level, token), fetchOptions).then(res => {
    if (res.ok) {
      return res.text();
    }
    throw new Error();
  });
};
